import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/adminportal/src/app/page.tsx");
